import { createGlobalStyle } from 'styled-components'
import colors from '../../theming/variables/colors'
import fonts from '../../theming/variables/fonts'

export const Html = createGlobalStyle`
  html {
    font-size: 10px;
    line-height: 1.5;
  }
`

export const Body = createGlobalStyle`
  body {
    color: ${colors.gray1};
    font-family: "${fonts.inter}";
    font-size: 1.4rem;
    font-weight: 600;
  }
`
